module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9r2r5n-8c76dc184ab4f5b0ec5fdda95528e79c.svg";